export default __webpack_public_path__ + "static/media/noun-location-point-4457421.0c91ec11.svg";